import { exportMindmapToText, importMindmapFromText } from './MindmapText';
import type { Mindmap } from './MindmapTypes';

export const TEXT_STORAGE_KEY = 'mindmap-v2:text:showcase';

export function tryLoadMindmapFromText(storage: Storage): Mindmap | null {
  const raw = storage.getItem(TEXT_STORAGE_KEY);
  if (!raw) return null;
  try {
    return importMindmapFromText(raw);
  } catch {
    return null;
  }
}

export function writeMindmapTextSnapshot(storage: Storage, mindmap: Mindmap): string {
  const text = exportMindmapToText(mindmap);
  storage.setItem(TEXT_STORAGE_KEY, text);
  return text;
}
